import { useState } from 'react';
import { CheckCircle2, FileSearch, MessageSquareText, Sparkles } from 'lucide-react';
import { getProductBySlug } from '../../data/products';

const DemoFrame = ({ product, children, compact }) => (
  <div className={`demo-frame${compact ? ' demo-frame--compact' : ''}`} data-product={product.accent}>
    <div className="demo-topbar">
      <div className="window-dots" aria-hidden="true"><i /><i /><i /></div>
      <span>Product simulation — synthetic sample data.</span>
    </div>
    {children}
  </div>
);

const FlowDemo = ({ product, compact }) => {
  const [view, setView] = useState('draft');
  return (
    <DemoFrame product={product} compact={compact}>
      <div className="demo-toolbar">
        <span className="demo-app"><MessageSquareText aria-hidden="true" /> Incoming order</span>
        <div className="segmented" aria-label="Flow view">
          <button aria-pressed={view === 'message'} className={view === 'message' ? 'active' : ''} onClick={() => setView('message')}>Message</button>
          <button aria-pressed={view === 'draft'} className={view === 'draft' ? 'active' : ''} onClick={() => setView('draft')}>Draft</button>
        </div>
      </div>
      {view === 'message' ? (
        <div className="chat-surface"><span className="avatar">BS</span><p>“{product.example.source}”</p></div>
      ) : (
        <div className="field-list">
          {product.example.output.map(([label, value]) => (
            <div key={label} className={value.includes('Confirm') || value.includes('needs') ? 'needs-review' : ''}>
              <span>{label}</span><strong>{value}</strong>
            </div>
          ))}
        </div>
      )}
      <div className="demo-status"><Sparkles aria-hidden="true" /> Draft has not changed business data</div>
    </DemoFrame>
  );
};

const CheckDemo = ({ product, compact }) => {
  const [selected, setSelected] = useState(1);
  return (
    <DemoFrame product={product} compact={compact}>
      <div className="demo-toolbar"><span className="demo-app"><FileSearch aria-hidden="true" /> Document analysis</span><span className="status-chip">1 finding</span></div>
      <div className="document-grid">
        {product.example.documents.map(([label, value], index) => (
          <button key={label} className={selected === index ? 'selected' : ''} onClick={() => setSelected(index)} aria-pressed={selected === index}>
            <span>{label}</span><strong>{value}</strong><small>DOC-00{index + 1}</small>
          </button>
        ))}
      </div>
      <div className="finding"><span>Review required</span><p>{product.example.finding}</p></div>
    </DemoFrame>
  );
};

const MemoryDemo = ({ product, compact }) => {
  const [showChange, setShowChange] = useState(true);
  return (
    <DemoFrame product={product} compact={compact}>
      <div className="demo-toolbar"><span className="demo-app"><CheckCircle2 aria-hidden="true" /> Conversation memory</span><button className="text-button" aria-pressed={showChange} onClick={() => setShowChange((value) => !value)}>{showChange ? 'View messages' : 'View changes'}</button></div>
      {showChange ? (
        <div className="change-list">
          {product.example.output.map(([label, value]) => <div key={label}><span>{label}</span><strong>{value}</strong></div>)}
        </div>
      ) : (
        <div className="message-timeline">
          {product.example.messages.map((message, index) => <p key={message}><small>{index ? 'Latest message' : 'Initial message'}</small>{message}</p>)}
        </div>
      )}
      <div className="demo-status"><CheckCircle2 aria-hidden="true" /> Awaiting team confirmation</div>
    </DemoFrame>
  );
};

const ProductDemo = ({ slug, compact = false }) => {
  const product = getProductBySlug(slug);
  if (!product) return null;
  if (slug === 'cosmic-check') return <CheckDemo product={product} compact={compact} />;
  if (slug === 'cosmic-memory') return <MemoryDemo product={product} compact={compact} />;
  return <FlowDemo product={product} compact={compact} />;
};

export default ProductDemo;
